import { QueryHookOptions } from '@apollo/client';

import { useInfiniteQuery } from 'hooks/useInfiniteQuery';

import query from './oemSegmentsFiltersQuery.graphql';

export const useOemSegmentsFiltersQuery = (
  options?: QueryHookOptions<
    OemSegmentsFiltersQuery,
    OemSegmentsFiltersQueryVariables
  >,
) => {
  return useInfiniteQuery(query, {
    fieldName: 'managedOemSegments',
    ...options,
  });
};
